// @ts-ignore
// eslint-disable-next-line no-undef
export default __REACT_NATIVE_WEB_CONFIG__;
